import { authService } from '../auth-service';
import AxiosService from '../axios-service';

function paymentsQuery(id) {
  const query = `
  query Payments {
    campaigns(id: "${id}") {
      id
      name
      budget
      teamDiscussion
      clientDiscussion
      discussions {
        id
        name
        budget
        budgetStatus
        members(role: "INFLUENCER") {
          id
          user {
            id
          }
          email
          role
          name
        }
      }
    }
  }`;
  return query;
}

export function getPaymentsData(id) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = paymentsQuery(id);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
  .then(res => res.data.data.campaigns[0]);
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/payments.js
 **/